import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import getWebAppRouteKey from '../services/getWebAppRouteKey';
import { nextJsRoutes } from '../constants/routes';
export default function useClientNavigate() {
  const $ = _c(2);
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = path => {
      if (!getWebAppRouteKey(path, nextJsRoutes)) {
        return false;
      }
      router.push(path);
      return true;
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}